import { Maybe } from "@biggeo/bg-server-lib/studio";
import { IconButton, Stack, Tooltip, Typography } from "@biggeo/bg-ui/lab";
import { Info, StopCircle } from "@biggeo/bg-ui/lab/icons";
import moment from "moment";
import { Counter } from "./Counter";

export const TurnOffCompute = ({
    onClick,
    lastEnabled,
}: {
    onClick: () => void;
    lastEnabled: Maybe<Date>;
}) => {
    const disabledUntil = lastEnabled
        ? moment(lastEnabled).add(24, "hours").toDate()
        : undefined;

    const isDisabled =
        disabledUntil &&
        new Date(disabledUntil).getTime() > new Date().getTime();

    return (
        <Stack
            gap={1}
            alignItems="center"
            justifyContent="center"
            width="100%"
            flexDirection="row"
        >
            <IconButton
                variant="tonal"
                density="dense"
                onClick={onClick}
                sx={{
                    borderRadius: (theme) => theme.radius.full,
                }}
                color="primary"
                disabled={isDisabled}
            >
                <StopCircle />
            </IconButton>
            <Stack>
                <Typography variant="body3" fontWeight="semibold">
                    Turn Off
                </Typography>
                {disabledUntil && <Counter date={disabledUntil} />}
            </Stack>
            {isDisabled && (
                <Tooltip
                    title={
                        "The dataset compute usage is locked on for the next 24hrs"
                    }
                    sx={{ maxWidth: 45 }}
                >
                    <span>
                        <Info color="primary" size="xs" />
                    </span>
                </Tooltip>
            )}
        </Stack>
    );
};
